<template>
  <div id="dashboard-analytics">
    <div class="vx-row" v-if="!paypingNotConnected">
      <div class="vx-col w-full mb-base">
        <vx-card slot="no-body" class="text-center bg-warning-gradient greet-user">
          <router-link :to="{ name: 'profile-settings' }">
            <feather-icon
              icon="InfoIcon"
              class="p-6 mb-8 bg-warning inline-flex rounded-full text-white shadow"
              svgClasses="h-8 w-8"
            ></feather-icon>
            <h1 class="mb-6 text-white">
              {{ $t('messages.payping_not_connected_warn') }}
            </h1>
          </router-link>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full mb-base">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
          <img
            src="@/assets/images/elements/decore-left.png"
            class="decore-left"
            alt="Decore Left"
            width="200"
          />
          <img
            src="@/assets/images/elements/decore-right.png"
            class="decore-right"
            alt="Decore Right"
            width="175"
          />
          <feather-icon
            icon="AwardIcon"
            class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
          <h1 class="mb-6 text-white">
            {{ $t('messages.congratulations') }}
          </h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
            {{ $t('messages.welcome_to_30teb_dashboard') }}
          </p>
          <div
            class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-primary text-lg bg-white p-5 mt-5 rounded-lg font-semibold"
          >
            <p class="mb-3">
              {{ $t('affiliate.your_referral_code', { code: referral }) }}
            </p>
            <vs-button
              icon-pack="feather"
              icon="icon-copy"
              size="small"
              type="gradient"
              color="primary"
              class="m-auto"
              @click="copyReferralLink"
            >
              {{ $t('affiliate.copy_referral_link') }}
            </vs-button>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card slot="no-body" class="text-center bg-warning-gradient greet-user">
          <router-link :to="{ name: 'profile-notifications' }">
            <feather-icon
              icon="BellIcon"
              class="p-6 mb-8 bg-warning inline-flex rounded-full text-white shadow"
              svgClasses="h-8 w-8"
            ></feather-icon>
            <h1 class="mb-6 text-white">{{ $t('notices.notices') }}</h1>
          </router-link>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card slot="no-body" class="text-center bg-success-gradient greet-user">
          <router-link :to="{ name: 'chat' }">
            <feather-icon
              icon="MessageCircleIcon"
              class="p-6 mb-8 bg-success inline-flex rounded-full text-white shadow"
              svgClasses="h-8 w-8"
            ></feather-icon>
            <h1 class="mb-6 text-white">{{ $t('chats.chats') }}</h1>
          </router-link>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '@/i18n/i18n'

export default {
  data() {
    return {
      referral: null
    }
  },
  computed: {
    paypingNotConnected() {
      return !(!this.$store.state.AppActiveUser.paypingOauthId && this.$acl.check('manager'))
    },
    referralLink() {
      return `https://next.30teb.app/r/${this.referral}`
    }
  },
  methods: {
    copyReferralLink() {
      const el = document.createElement('textarea')
      el.value = this.referralLink
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
      this.$notifySuccess(i18n.t('messages.your_referral_link_copied'))
    }
  },
  created() {
    this.$store.dispatch('affiliate/getAffiliateCode').then(res => {
      this.referral = res.data
    })
  }
}
</script>
